import React from 'react';
import decode from 'Utils/entities';
import SvgIcon from 'Components/svg/SvgIcon';

let PmFolderComponent = ( { folder } ) => {
	let unread_counter = ( folder.unread > 0
		? <span className="unreadCounter"><SvgIcon size="12px" icon="error_outline" />{ `${folder.unread} new message${ folder.unread === 1 ? '' : 's' }` }</span>
		: null
	);

	return (
		<div className="nolinks">
			<div className="name">
				{ decode( folder.name ) }
			</div>
			<div className="stats">
				<span className="left-stats">
					<SvgIcon size="12px" icon="message" />
					{ `${ folder.count } message${ folder.count === 1 ? '' : 's' }` }
				</span>
				{ unread_counter }
			</div>
		</div>
	)
};

export default PmFolderComponent;


// WEBPACK FOOTER //
// ./src/components/messages/FolderComponent.js